import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [
        'hiddenLink'

    ]
    initialize() {
        super.initialize();
    }

    connect() {
        const hiddenLink = this.hiddenLinkTarget;
        const hrefAttributeValue = hiddenLink.getAttribute('href');
        if (hrefAttributeValue.trim().toLowerCase() === '/logout/') {
            setTimeout(function () {
                window.location.href = '/logout/';
            }, 3000);
        } else {
            setTimeout(function () {
                hiddenLink.click();
            }, 1);
        }
    }

}